import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminGuard } from 'src/app/shared/guard/admin.guard';
import { DashboardComponent } from './dashboard.component';
import { CryptoGuard } from 'src/app/shared/guard/crypto.guard';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'reports',
        title: 'Relatórios',
        component: DashboardComponent,
        canActivate: [AdminGuard, CryptoGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
